export const ALL = "ALL";
export const VIEW_DELIVERY_DASHBOARD = "VIEW_DELIVERY_DASHBOARD";
export const ADD_EDIT_REMOVE_USERS = "ADD_EDIT_REMOVE_USERS";
export const VIEW_STATISTICS = "VIEW_STATISTICS";
export const EDIT_SETTINGS = "EDIT_SETTINGS";
export const UPDATE_SHIFT_MEMBERS_AVAILABILITY = "UPDATE_SHIFT_MEMBERS_AVAILABILITY";
export const UPDATE_SHIFT_MEMBERS = "UPDATE_SHIFT_MEMBERS";
export const ADD_EDIT_SHIPMENT = "ADD_EDIT_SHIPMENT";
export const EDIT_SHIPMENT_STATUS = "EDIT_SHIPMENT_STATUS";
export const VIEW_ORDERS = "VIEW_ORDERS";
export const VIEW_MAP = "VIEW_MAP";
export const VIEW_REPORTS = "VIEW_REPORTS";
export const VIEW_MANUAL_ADDRESS_CACHE = "VIEW_MANUAL_ADDRESS_CACHE";
export const ADD_MESSENGER_MANUAL_OWE_TRANSACTION = "ADD_MESSENGER_MANUAL_OWE_TRANSACTION";
export const ADD_MESSENGER_ORDER_OWE_TRANSACTION = "ADD_MESSENGER_ORDER_OWE_TRANSACTION";
export const ADD_MESSENGER_MANUAL_OWE = "ADD_MESSENGER_MANUAL_OWE";
export const DELETE_MESSENGER_MANUAL_OWE = "DELETE_MESSENGER_MANUAL_OWE";
export const VIEW_MESSENGERS_OWES = "VIEW_MESSENGERS_OWES";